import { ArrayBase } from '@master/model/ArrayBase'
import { ClientBase } from '@master/model/ClientBase';

export const YearsSupportMap = {
  son: {
    label: 'Son',
    year: 25
  },
  daughter: {
    label: 'Daughter',
    year: 23
  },
  male: {
    label: 'Male',
    year: 82
  },
  female: {
    label: 'Female',
    year: 86
  }
}

export default class EIDetails extends ClientBase {
  EIskipExistingInvestment: 'no_existing_investment' | 'no_disclose' | 'fully_disclose_investment' | '' = '';

  EIskipRemark = '';
 
  EIDexistingInvestment = [];

  existingInvestmentAdditionalNotes='';

  discloseExistingInvestments?: boolean;
  anyExistingInvestments?: boolean;
  fullyDiscloseExistingInvestments?: boolean;

  constructor (type: 'client_0' | 'client_1' = 'client_0') {
    super(type);
    this.EIDexistingInvestment = [];
  }

  setEIskipExistingInvestment(newValue) {
    this.EIskipExistingInvestment = newValue;
    this.discloseExistingInvestments = newValue === 'no_disclose';
    this.anyExistingInvestments = newValue === 'no_existing_investment';
    this.fullyDiscloseExistingInvestments = newValue === 'fully_disclose_investment';
  }

  setData(newData) {
    for (const key in newData) {
      if (this.hasOwnProperty(key)) { 
        this[key] = newData[key];
      }
    }
    // Mapping BE response with FE model
    if (newData?.discloseExistingInvestments === true && !newData?.anyExistingInvestments && !newData?.fullyDiscloseExistingInvestments) {
      this.EIskipExistingInvestment = 'no_disclose';
    } else if (newData?.anyExistingInvestments === true && !newData?.discloseExistingInvestments && !newData?.fullyDiscloseExistingInvestments) {
      this.EIskipExistingInvestment = 'no_existing_investment';
    } else if (!newData?.anyExistingInvestments === true && !newData?.discloseExistingInvestments && newData?.fullyDiscloseExistingInvestments) {
      this.EIskipExistingInvestment = 'fully_disclose_investment';
    }
    if (newData.discloseExistingInvestmentsRemarks !== null && newData.discloseExistingInvestmentsRemarks !== undefined) {
      this.EIskipRemark = newData?.discloseExistingInvestmentsRemarks;
    }

  }
  toJSON() {
   
    const val ={
      discloseExistingInvestments: this.EIskipExistingInvestment === 'no_disclose',
      anyExistingInvestments: this.EIskipExistingInvestment === 'no_existing_investment',
      fullyDiscloseExistingInvestments:this.EIskipExistingInvestment === 'fully_disclose_investment',
      discloseExistingInvestmentsRemarks: this.EIskipRemark,
      existingInvestmentAdditionalNotes: this.existingInvestmentAdditionalNotes,
    }
    return val;
  }
}

export class Investments extends ArrayBase {
  type = 'existingInvestment'
  id?: string='';
  typeOfInvestments?:string= '';
  cashCpfSrs?:string= '';
  investmentsAmount?:number = undefined;
  currentValue?: number= undefined;
  remarksInvestment?: string = '';
  
  constructor (type: 'client_0' | 'client_1' = 'client_0') {
    super();
  }

}